import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue";
import { StaffMember } from "@/modules/staff/entity";
import QueryPaginator from "@/modules/vue/components/QueryPaginator.vue";
import StaffMemberComponent from "@/modules/staff/components/StaffMember.vue";
import StaffMemberLayout from "@/modules/staff/pages/StaffMemberLayout.vue";
import { app } from "@/di";
import { EventEmitter } from "@/modules/base/events";
import { AfterSackStaffMemberEvent } from "@/modules/staff/events/AfterSackStaffMemberEvent";
export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {
    const query = ref(StaffMember.createQueryBuilder('member').innerJoinAndSelect('member.team', 'team').where('team.user = true'));
    const layout = ref(null);
    const paginator = ref(null);
    const refresh = async () => {
      await layout.value.refresh();
      await paginator.value.refresh();
    };
    onUnmounted(app.get(EventEmitter).onOff(AfterSackStaffMemberEvent, refresh));
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(StaffMemberLayout, {
        ref_key: "layout",
        ref: layout
      }, {
        default: _withCtx(() => [_createVNode(QueryPaginator, {
          ref_key: "paginator",
          ref: paginator,
          query: query.value
        }, {
          default: _withCtx(({
            items
          }) => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items, staffMember => {
            return _openBlock(), _createBlock(StaffMemberComponent, {
              key: staffMember.id,
              "staff-member": staffMember,
              onSacked: refresh
            }, null, 8, ["staff-member"]);
          }), 128))]),
          _: 1
        }, 8, ["query"])]),
        _: 1
      }, 512);
    };
  }
});